import VwKurumKullaniciDTO from 'src/models/Settings/Generals/VwKurumKullaniciDTO';
import { ApiService } from 'src/services/core';

class VwKurumKullaniciService extends ApiService<VwKurumKullaniciDTO> {
  constructor() {
    super('VwKurumKullaniciDTO');
  }
}
export default new VwKurumKullaniciService();
